import { useQueryFetch } from '../useQueryFetch';
import { Service } from './Constants';

interface ServiceStatusResponse {
  error: boolean;
  message: any;
}

export const useServiceStatus = (service: Service) => {
  const { data, error, loading } = useQueryFetch({
    pathname: `/${service}/status`,
    autoFetch: true,
  });

  const statusData: ServiceStatusResponse = (data && data.data) || null;

  return { statusData, loading, error };
};
